import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PriceType} from "../../../price-plan/types/price.type";
import {FulfillmentLineType} from "../../../oms/types/fulfillment-line.type";
import {LocationType} from "../../../commons/types/location.type";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {getFulfillmentLineItems} from "../../utils/fulfillment-line-items.util";

export class FulfillmentTaskFormCtrl implements IController {

  order: any;
  orderAccount: any;
  fulfillmentLine: any;
  isEdit: boolean;
  isInvalidForm: boolean;
  isOmsPackageDimensionMandatory: boolean;
  canAddLine: boolean;
  isDisableLineSelect: boolean;
  onAddPackages: Function;
  onRemovePackage: Function;
  onPricePlanChange: Function;
  onRemoveLine: Function;
  onAddLine: Function;
  onFulfillmentLineChange: Function;
  onPackageChange: Function;
  onFulfillmentLineTypeChange: Function;

  private siteInfo: any;
  private fulfillmentLineData: any;
  private addMarkerPurpose: any;
  private proxyProviderType: any;
  private isWeightInTotal: boolean;
  public fulfillmentLineType: typeof FulfillmentLineType = FulfillmentLineType;
  public locationTypes: typeof LocationType = LocationType;
  public sitePackageItemsMap: any;
  public linePackageNames: string[] = [];
  public pricePlanBundle: any;
  public defaultProgram: any;
  public isAllowOnlyOnePackagePerLineInOms: boolean;
  public numOfPackagesToAdd: number;
  public fulfillmentLineTypeOptions: string[];

  constructor(private packageConfigurationService: PackageConfigurationService, private omsService: OmsService, private ordersService: OrdersService, private moment, private siteContextService: SiteContextService,
              private splitService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
  }

  $onInit() {
    this.numOfPackagesToAdd = 1;
    this.fulfillmentLineTypeOptions = Object.keys(FulfillmentLineType);
    this.isWeightInTotal = this.siteInfo.isOmsPackageTotalWeight;
    this.proxyProviderType = this.siteInfo.proxyProviderType;
    this.isAllowOnlyOnePackagePerLineInOms = this.splitService.isAllowOnlyOnePackagePerLineInOms();
    this.fulfillmentLineData = {
      lineSections: {
        pickup: true,
        destination: true,
        packages: true
      }
    };

    if (this.fulfillmentLine.type === this.fulfillmentLineType.ReturnDelivery) {
      this.fulfillmentLineData.lineSections.pickup = false;
      this.fulfillmentLineData.lineSections.destination = false;
      this.fulfillmentLineData.lineSections.packages = true;
    }

    this.fulfillmentLineData.linePackages = getFulfillmentLineItems(this.fulfillmentLine, this.order.itemLines);

    this._mapPackages();

    if (this.orderAccount?.id && this.fulfillmentLine.type) {
      this._getLineSettings(this.orderAccount.id, this.fulfillmentLine.type);
      // if (this.fulfillmentLine.programType) {
      //   this._loadFulfillmentSettings(this.orderAccount.id, this.fulfillmentLine.programType, this.fulfillmentLine.type);
      // }
    }

  }


  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.orderAccount && !changes.orderAccount.isFirstChange()) {
      const currentOrderAccount: any = _.get(changes, 'orderAccount.currentValue', []),
        previousOrderAccount: any = _.get(changes, 'orderAccount.previousValue', []);
      if (!!previousOrderAccount && !_.isEqual(currentOrderAccount.id, previousOrderAccount.id)) {
        this._checkLineData(previousOrderAccount.id);
        if (this.orderAccount?.id && this.fulfillmentLine.type) {
          this._getLineSettings(this.orderAccount.id, this.fulfillmentLine.type);
        }
      }
    }

    if (changes.fulfillmentLine && !changes.fulfillmentLine.isFirstChange()) {
      const currentFulfillmentLineType: any = _.get(changes, 'fulfillmentLine.currentValue.type'),
        previousFulfillmentLineType: any = _.get(changes, 'fulfillmentLine.previousValue.type');
      if (!_.isEqual(previousFulfillmentLineType, currentFulfillmentLineType) && this.orderAccount?.id && this.fulfillmentLine.type) {
        this._getLineSettings(this.orderAccount.id, this.fulfillmentLine.type);
      }
    }

    if (changes.order && !changes.order.isFirstChange()) {
      this.fulfillmentLineData.linePackages = [];
      this.fulfillmentLineData.linePackages = getFulfillmentLineItems(this.fulfillmentLine, this.order.itemLines);

      this._mapPackages();
    }

    if (changes.isInvalidForm && !changes.isInvalidForm.isFirstChange()) {
      if (this.isInvalidForm) {
        this.fulfillmentLineData.lineSections.pickup = true;
        this.fulfillmentLineData.lineSections.destination = true;
        this.fulfillmentLineData.lineSections.packages = true;
      }
    }

  }

  private _getLineSettings(accountId, lineType) {
    let serviceType: FulfillmentLineType;

    if (lineType === this.fulfillmentLineType.ReturnDelivery || lineType === this.fulfillmentLineType.Exchange) {
      serviceType = this.fulfillmentLineType.Delivery
    } else if (lineType === this.fulfillmentLineType.UnifiedService) {
      serviceType = this.fulfillmentLineType.Operation;
    } else {
      serviceType = lineType;
    }
    this.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType(accountId, serviceType)
      .then((defaultProgram) => {

        this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(accountId)
          .then((pricePlanBundle) => {
            this.pricePlanBundle = pricePlanBundle;
            this.defaultProgram = _.find(pricePlanBundle.entryList, (e) => {
              return e.id === defaultProgram.id;
            })
            this._setFulfillmentSettings();
          })
      })
  }

  swapTasks(fulfillmentLine) {
    this.omsService.swapOriginDestination(fulfillmentLine)
  }

  onToggleCustomAddress(purpose) {
    this.addMarkerPurpose = _.isEqual(this.addMarkerPurpose, purpose) ? undefined : purpose;
  }

  changePricePlan(pricePlan) {
    if (!!pricePlan && _.get(this.fulfillmentLine, 'programType') !== _.get(pricePlan, 'type')) {
      this.fulfillmentLine.programName = pricePlan.name;
      this.fulfillmentLine.programType = pricePlan.type;
      this.fulfillmentLineData.selectedProgram = pricePlan;
      this._setShowSpots();
      this.fulfillmentLineData.isShowSpots = this.fulfillmentLineData.selectedProgram.programSetting.priceType === PriceType.BySpot;
      this._loadFulfillmentSettings(this.orderAccount.id, pricePlan.type, this.fulfillmentLine.type);
      this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
    }
  }


  onAddressChange(address, purpose) {
    this._setTaskAddress(address, purpose)
  }

  onOriginTaskDateChange(notBefore, notAfter) {
    if (this.fulfillmentLine.destinationTask.notBefore < notBefore && !this.moment(this.fulfillmentLine.destinationTask.notBefore).isSame(this.moment(notBefore), 'day')) {
      this.fulfillmentLine.destinationTask.notBefore = this.moment(notBefore).startOf('day').valueOf();
      this.fulfillmentLine.destinationTask.notAfter = this.moment(notBefore).endOf('day').valueOf();
    }
  }

  onDestinationTaskDateChange(notBefore, notAfter) {
    if (this.fulfillmentLine.pickupTask.notBefore > notBefore && !this.moment(this.fulfillmentLine.pickupTask.notBefore).isSame(this.moment(notBefore), 'day')) {
      this.fulfillmentLine.pickupTask.notBefore = this.moment(notBefore).startOf('day').valueOf();
      this.fulfillmentLine.pickupTask.notAfter = this.moment(notBefore).endOf('day').valueOf();
    }
    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
  }

  addPackages(numOfPackages: number) {
    if (numOfPackages < 1) return;

    const defaultItemSizeItem = _.find(this.fulfillmentLineData.packagesSizes, (p) => {
      return p.itemSize === this.fulfillmentLineData.defaultItemSize;
    });
    if (defaultItemSizeItem) {
      this.fulfillmentLineData.defaultItemSize = angular.copy(_.get(defaultItemSizeItem, 'itemSize'));
    }

    // A line without itemIds is connected to all packages - keep them connected once it gets an explicit list
    if (!this.fulfillmentLine.itemIds) {
      this.fulfillmentLine.itemIds = _.map(this.fulfillmentLineData.linePackages, 'id');
    }

    // const newItem = this.createItem(this.fulfillmentLine, defaultItemSizeItem);
    const packagesToAdd = Array(numOfPackages)
      .fill(undefined)
      .map((_, i) => this.createItem(this.fulfillmentLine, defaultItemSizeItem, this.fulfillmentLine.itemIds?.length ? this.fulfillmentLine.itemIds?.length + i + 1 : i));

    this.fulfillmentLine.itemIds.push(...packagesToAdd.map(ni => ni.id));
    if (!this.fulfillmentLineData.linePackages) {
      this.fulfillmentLineData.linePackages = [];
    }
    this.fulfillmentLineData.linePackages.push(...packagesToAdd);
    this._mapPackages();
    this.onAddPackages({items: packagesToAdd, fulfillmentLineId: this.fulfillmentLine.id});
    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
  }

  removePackage(itemId) {
    this.fulfillmentLine.itemIds = _.filter(this.fulfillmentLine.itemIds ?? _.map(this.fulfillmentLineData.linePackages, 'id'), id => {
      return id !== itemId
    });

    const fulfillmentLinePackageIndex = _.findIndex(this.fulfillmentLineData.linePackages, (p: any) => {
      return p.id === itemId;
    })
    this.fulfillmentLineData.linePackages.splice(fulfillmentLinePackageIndex, 1);
    this._mapPackages();

    this.onRemovePackage({itemId: itemId});
    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
  }

  onAttachmentsChange(attachments) {
    this.fulfillmentLine.attachments = attachments;
    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
  }

  private _mapPackages() {
    this.linePackageNames = [];
    this.linePackageNames = _.map(this.fulfillmentLineData.linePackages, packageItem => {
      return this.sitePackageItemsMap[packageItem.type]?.name;
    })
  }

  private _setShowSpots(fulfillmentLineProgramType?) {
    let entryListDefaultProgram;
    if (fulfillmentLineProgramType) {
      entryListDefaultProgram = _.find(_.get(this.pricePlanBundle, 'entryList', []), (e) => {
        return e.type === fulfillmentLineProgramType;
      })
    } else {
      entryListDefaultProgram = _.find(_.get(this.pricePlanBundle, 'entryList', []), (e) => {
        return e.id === this.defaultProgram?.id;
      })
    }
    this.fulfillmentLineData.isShowSpots = _.get(entryListDefaultProgram, 'programSetting.priceType') === PriceType.BySpot;
  }

  private _checkLineData(previousAccountId) {
    //Pickup
    if (this.fulfillmentLine.pickupTask?.location) {
      if (this.fulfillmentLine.pickupTask.location.locationType === this.locationTypes.ACCOUNT &&
        this.fulfillmentLine.pickupTask.location.id === previousAccountId) {
        this.fulfillmentLine.pickupTask.location.id = _.get(this.orderAccount, 'id');
        this.fulfillmentLine.pickupTask.location.locationType = this.orderAccount ? LocationType.ACCOUNT : undefined;
        this.fulfillmentLine.pickupTask.location.address = _.get(this.orderAccount, 'address', {});
        if (!this.fulfillmentLine.pickupTask.contact) {
          this.fulfillmentLine.pickupTask.contact = {}
        }
        this.fulfillmentLine.pickupTask.contact.name = _.get(this.orderAccount, 'name');
        this.fulfillmentLine.pickupTask.contact.businessName = _.get(this.orderAccount, 'name');
        this.fulfillmentLine.pickupTask.contact.phoneNo = _.get(this.orderAccount, 'phoneNumber');
      }
    }

    //Destination
    if (this.fulfillmentLine.destinationTask?.location) {
      if (this.fulfillmentLine.destinationTask.location.locationType === this.locationTypes.ACCOUNT &&
        this.fulfillmentLine.destinationTask.location.id === previousAccountId) {
        this.fulfillmentLine.destinationTask.location.id = _.get(this.orderAccount, 'id');
        this.fulfillmentLine.destinationTask.location.locationType = this.orderAccount ? LocationType.ACCOUNT : undefined;
        this.fulfillmentLine.destinationTask.location.address = _.get(this.orderAccount, 'address', {});
        if (!this.fulfillmentLine.destinationTask.contact) {
          this.fulfillmentLine.destinationTask.contact = {}
        }
        this.fulfillmentLine.destinationTask.contact.name = _.get(this.orderAccount, 'name');
        this.fulfillmentLine.destinationTask.contact.businessName = _.get(this.orderAccount, 'name');
        this.fulfillmentLine.destinationTask.contact.phoneNo = _.get(this.orderAccount, 'phoneNumber');
      }
    }

    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
  }

  private _setFulfillmentSettings() {
    if (this.fulfillmentLine.programType) {
      const isFulfillmentProgramTypeInPriceBundleEnabled = _.find(_.get(this.pricePlanBundle, 'entryList', []), (e) => {
        return e.type === this.fulfillmentLine.programType;
      })?.enabled;
      if (!isFulfillmentProgramTypeInPriceBundleEnabled) {
        this._setProgram()
      } else {
        this._loadFulfillmentSettings(this.orderAccount.id, this.fulfillmentLine.programType, this.fulfillmentLine.type);
        this._setShowSpots(this.fulfillmentLine.programType);
      }
    } else {
      this._setProgram();
    }

  }

  private _setProgram() {
    if (this.pricePlanBundle.defaultPricePlanProgramType) {
      this.fulfillmentLineData.selectedProgram = _.find(this.pricePlanBundle.entryList, e => {
        return e.type === this.pricePlanBundle.defaultPricePlanProgramType;
      })
      this._setShowSpots();
      this._loadFulfillmentSettings(this.orderAccount.id, this.fulfillmentLineData.selectedProgram.type, this.fulfillmentLine.type);
    } else if (this.defaultProgram.enabled) {
      this.fulfillmentLineData.selectedProgram = this.defaultProgram;
      this._loadFulfillmentSettings(this.orderAccount.id, this.defaultProgram.type, this.fulfillmentLine.type);
      this._setShowSpots();
    } else {
      this.fulfillmentLineData.selectedProgram = _.find(this.pricePlanBundle.entryList, e => {
        return e.enabled;
      })
      if (this.fulfillmentLineData.selectedProgram) {
        this._setShowSpots();
        this._loadFulfillmentSettings(this.orderAccount.id, this.fulfillmentLineData.selectedProgram.type, this.fulfillmentLine.type);
      }
    }
    if (this.fulfillmentLineData?.selectedProgram?.type) {
      this.fulfillmentLine.programType = this.fulfillmentLineData.selectedProgram.type;
      this.fulfillmentLine.programName = this.fulfillmentLineData.selectedProgram.name;
      this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
    }
  }

  private _loadFulfillmentSettings(accountId, programType, serviceType) {
    this.ordersService.getOrderSettings(accountId, serviceType, programType, undefined)
      .then((orderSettings) => {
        this.fulfillmentLineData.availableDays = _.get(orderSettings, 'availableDays', []);

        const todayQuote = _.find(this.fulfillmentLineData?.availableDays, (q) => {
          return this.moment(q).isSame(this.moment(), 'day');
        });

        if (!this.isEdit) {
          if (this.fulfillmentLine.type !== this.fulfillmentLineType.Operation) {
            this.fulfillmentLine.pickupTask.notBefore = todayQuote ? this.moment(todayQuote).startOf('day').valueOf() : (this.fulfillmentLineData.availableDays[0] ? this.moment(this.fulfillmentLineData.availableDays[0]).startOf('day').valueOf() : this.moment().startOf('day').valueOf());
            this.fulfillmentLine.pickupTask.notAfter = todayQuote ? this.moment(todayQuote).endOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf() : (this.fulfillmentLineData.availableDays[0] ? this.moment(this.fulfillmentLineData.availableDays[0]).endOf('day').set({
                'minute': 30,
                'second': 0,
                'millisecond': 0
              }).valueOf() :
              this.moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf());
          }

          this.fulfillmentLine.destinationTask.notBefore = todayQuote ? this.moment(todayQuote).startOf('day').valueOf() : (this.fulfillmentLineData.availableDays[0] ? this.moment(this.fulfillmentLineData.availableDays[0]).startOf('day').valueOf() : this.moment().startOf('day').valueOf());
          this.fulfillmentLine.destinationTask.notAfter = todayQuote ? this.moment(todayQuote).endOf('day').set({
            'minute': 30,
            'second': 0,
            'millisecond': 0
          }).valueOf() : (this.fulfillmentLineData.availableDays[0] ? this.moment(this.fulfillmentLineData.availableDays[0]).endOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf() :
            this.moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf());
        }

        this.fulfillmentLineData.packagesSizes = orderSettings.itemSizeList;
        this.fulfillmentLineData.defaultItemSize = orderSettings.defaultItemSize;
        this.fulfillmentLineData.spotDimensions = orderSettings.spotDimensions;
        this.fulfillmentLineData.spotWeight = orderSettings.spotWeight;
        this.fulfillmentLineData.additionOptions = _.get(orderSettings, 'additions', []);
        this.fulfillmentLineData.additionOptions = _.get(orderSettings, 'additions', []);

        this.fulfillmentLineData.identificationOptions = {
          pickup: this.ordersService.buildIdentificationOptions(
            orderSettings.omsPickupPodSettings,
            orderSettings.omsPickupPodFillRequiredSettings
          ),
          dropoff: this.ordersService.buildIdentificationOptions(
            orderSettings.omsDropoffPodSettings,
            orderSettings.omsDropoffPodFillRequiredSettings
          )
        };

        if (this.fulfillmentLine.pickupTask) {
          _.forEach(this.fulfillmentLine.pickupTask.additions, (a, index) => {
            if (!_.includes(_.map(orderSettings.additions, 'id'), a.id)) {
              this.fulfillmentLine.pickupTask.additions.splice(index, 1);
            }
          });
          if (_.isEmpty(this.fulfillmentLine.pickupTask.identifications)) {
            this.fulfillmentLine.pickupTask.identifications = this.ordersService.buildDefaultIdentifications(
              orderSettings.omsPickupPodSettings,
              orderSettings.omsPickupPodFillRequiredSettings
            );
          }
        }

        if (this.fulfillmentLine.destinationTask) {
          _.forEach(this.fulfillmentLine.destinationTask.additions, (a, index) => {
            if (!_.includes(_.map(orderSettings.additions, 'id'), a.id)) {
              this.fulfillmentLine.pickupTask.additions.splice(index, 1);
            }
          });
          if (_.isEmpty(this.fulfillmentLine.destinationTask.identifications)) {
            this.fulfillmentLine.destinationTask.identifications = this.ordersService.buildDefaultIdentifications(
              orderSettings.omsDropoffPodSettings,
              orderSettings.omsDropoffPodFillRequiredSettings
            );
          }
        }


        // if (!this.fulfillmentLine.itemIds.length) {
        //
        //   const defaultItemSizeItem = _.find(this.fulfillmentLineData.packagesSizes, (p) => {
        //     return p.itemSize === _.get(orderSettings, 'defaultItemSize');
        //   });
        //   if (defaultItemSizeItem) {
        //     const newItem = this.createItem(this.fulfillmentLine, defaultItemSizeItem);
        //     this.fulfillmentLine.itemIds.push(newItem.id);
        //     if (!this.fulfillmentLineData.linePackages) {
        //       this.fulfillmentLineData.linePackages = [];
        //     }
        //     this.fulfillmentLineData.linePackages.push(newItem);
        //     this._mapPackages();
        //     this.onAddPackage({fulfillmentLine: this.fulfillmentLine, item: newItem});
        //     this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine});
        //   }
        // }
      })
  }

  private createItem(fulfillmentLine, defaultItemSizeItem, idSuffix: number) {
    const itemId = 'line_' + fulfillmentLine.id + '_' + idSuffix;
    // const configuredFields = this.packageConfigurationService.getEmptyPackageConfiguredFieldsWithoutValues(_.get(defaultItemSizeItem, 'itemSize'));

    return {
      count: 1,
      id: itemId,
      barcode: null,
      type: _.get(defaultItemSizeItem, 'itemSize'),
      labels: _.get(defaultItemSizeItem, 'labels', []),
      dimensions: _.get(defaultItemSizeItem, 'dimensions', {}),
      weight: _.get(defaultItemSizeItem, 'weight'),
      totalWeight: this.isWeightInTotal ? _.get(defaultItemSizeItem, 'weight') : undefined,
      // configuredFields: configuredFields
    };
  }

  private _setTaskAddress(address, purpose) {
    if (purpose === 'Pickup') {
      this.fulfillmentLine.pickupTask.location.address = address;
    }
    if (purpose === 'Destination') {
      this.fulfillmentLine.destinationTask.location.address = address;
    }
    this.onFulfillmentLineChange({fulfillmentLine: this.fulfillmentLine})
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineForm', {
    require: {
      form: '^form'
    },
    bindings: {
      order: '<',
      orderAccount: '<?',
      fulfillmentLine: '<',
      isEdit: '<?',
      isInvalidForm: '<?',
      isOmsPackageDimensionMandatory: '<',
      canAddLine: '<?',
      isDisableLineSelect: '<?',
      onAddPackages: '&',
      onRemovePackage: '&',
      onPricePlanChange: '&',
      onRemoveLine: '&',
      onAddLine: '&',
      onPackageChange: '&',
      onFulfillmentLineChange: '&',
      onFulfillmentLineTypeChange: '&'
    },
    template: require('./fulfillment-line-form.html').default,
    controller: FulfillmentTaskFormCtrl
  });
